<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">group_work</mat-icon>
    WORKFLOW NOTES
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<!-- No data message -->
<div *ngIf="dataSource!.data.length == 0 && !showSpinner" class="no-data">
  No Notes Available
</div>

<mat-dialog-content>
  <div class="top" *ngIf="dataSource!.data.length != 0  && !showSpinner"> 
    <p class="documentid-label"><strong>Document ID:</strong> {{ data.DocumentId }}</p> 
  </div>
  <div class="bottom">
    <mat-spinner *ngIf="showSpinner" style="margin: auto; display: block;"></mat-spinner>
    <!-- Table shown only if there is data -->
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8"
      *ngIf="dataSource!.data.length != 0  && !showSpinner">

      <ng-container matColumnDef="entryDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%;">Entry Date</th>
        <td mat-cell *matCellDef="let row">{{ row.entryDate }}</td>
      </ng-container>
      <ng-container matColumnDef="entryUsername">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%;">Entry User Name</th>
        <td mat-cell *matCellDef="let row">{{ row.entryUsername }}</td>
      </ng-container>

      <ng-container matColumnDef="entryUserFullName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%;">Entry User FullName</th>
        <td mat-cell *matCellDef="let row">{{ row.entryUserFullName }}</td>
      </ng-container>
      <ng-container matColumnDef="text">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 25%;">Comments</th>
        <td mat-cell *matCellDef="let row">{{ row.text }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div *ngIf="hideSave" class="notes-container">
    <mat-label class="notes-label">Add Notes</mat-label>
  
    <div class="matForm notes-form">
      <mat-form-field class="custom-form-field  notes-field">
        <textarea matInput [(ngModel)]="comment" maxlength="2000" rows="3"
          placeholder="Add your Notes here (max 2000 characters)">
      </textarea>
        <mat-hint align="end">{{ comment?.length || 0 }} / 2000</mat-hint>
      </mat-form-field>
    </div>
  
    <mat-dialog-actions>
      <button mat-flat-button class="submit" (click)="onSaveComment()" [disabled]="!comment">Submit</button>
    </mat-dialog-actions>
  </div>
</mat-dialog-content>